// extracted by mini-css-extract-plugin
export default {"content":"qaRowvJxyH","tabs":"OviGVB7ZIU","list":"hsSMfkHMgB"};